import { call, put, takeLatest } from "redux-saga/effects";
import { httpGetTransactions } from "../../../services/transactions";

import {
  fetchTransactionsStart,
  fetchTransactionsFailure,
  fetchTransactionsSuccess,
  setFilteredTransactions,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";

function* getTransactions({ payload }) {
  const { onSuccess, onFailure, options } = payload;
  const response = yield call(httpGetTransactions, payload);

  const { success, raw, message, statusCode } = response;

  if (success) {
    if (options.isFiltering) {
      yield put(setFilteredTransactions(raw));
    } else {
      yield put(fetchTransactionsSuccess(raw));
    }

    if (onSuccess) {
      onSuccess();
    }
  } else {
    yield put(fetchTransactionsFailure(raw));
    networkErrorHandler(statusCode, message);

    if (onFailure) {
      onFailure();
    }
  }
}

export default function* onGetTransactions() {
  yield takeLatest(fetchTransactionsStart.type, getTransactions);
}
